export const METHOD = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    LOGIN: 'LOGIN',
    DELETE: 'DELETE'
}

export const PER_FORMED_BY = 'PERFORMED-BY'